import { Grid } from "@mui/material";
import {
    ConditionPrimitive as ConditionPrimitiveClass,
    ICondition,
} from "models/LLMs";
import React from "react";
import { ConditionPrimitive } from "./ConditionPrimitive";
import { useCurrentStepAction } from "../StepAction";

interface ConditionProps {
    condition: ICondition;
}

export function Condition(props: ConditionProps) {
    const action = useCurrentStepAction();

    if (props.condition instanceof ConditionPrimitiveClass) {
        return (
            <ConditionPrimitive condition={props.condition}>
                <ConditionPrimitive.PropertyType />
                <ConditionPrimitive.PropertyName />
                <ConditionPrimitive.ExpressionType />
                <ConditionPrimitive.Value />
                <ConditionPrimitive.IsCaseSensitive />
                <ConditionPrimitive.Remove
                    onRemove={(condition) => action.removeCondition(condition)}
                />
            </ConditionPrimitive>
        );
    }

    console.warn("Attempted to render unsupported condition.");
    return null;
}

Condition.Container = ConditionContainer;
Condition.Primitive = ConditionPrimitive;

function ConditionContainer(props: React.PropsWithChildren) {
    return (
        <Grid
            container
            item
            columnGap={1}
            justifyContent="space-evenly"
            alignItems="center"
            flexWrap="nowrap"
        >
            {props.children}
        </Grid>
    );
}
